import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';

@customElement('webs-cards-general')
export class CardsGeneral extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      ::slotted(webs-card-solid){
        display: block;
        margin: 0.8rem 0;
      }

    `]



  @property({attribute: 'space-top'})
  spaceTop = 'm'

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';



  protected render(): unknown {
    return html`
    <section class="m-cards-general ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : '' } ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : '' }">
      <div class="container">
        <webs-grid-row>
          <slot></slot>
        </webs-grid-row>
      </div>
    </section>
    `
  }
  connectedCallback() {
    let lastKnownScrollPosition = 0;
    let ticking = false;

    super.connectedCallback();
    document.addEventListener('scroll', (e) => {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking && window.innerWidth < 576) {
        window.requestAnimationFrame(() => {
          const items = this.shadowRoot.querySelector<any>('slot').assignedElements();
          const cardHeight = 164;
          items.forEach(element => {
            const card = element.shadowRoot.querySelector('.m-cards-solid__card');
            if(element.getBoundingClientRect().top >= ((window.innerHeight / 2) - cardHeight)) {
              card.classList.add('active');
            } else {
              card.classList.remove('active');
            }
            if(element.getBoundingClientRect().top >= (window.innerHeight / 2)) {
              card.classList.remove('active');
            }
          });
          ticking = false;
        });

        ticking = true;
      }
    });
  }
}
